import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

type Props = {
  open: boolean;
  folderName: string;
  subfolderCount: number;
  fileCount: number;
  requiresConfirmation: boolean;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function DeleteFolderModal({
  open,
  folderName,
  subfolderCount,
  fileCount,
  requiresConfirmation,
  isDeleting = false,
  onClose,
  onConfirm,
}: Props) {
  const hasContent = subfolderCount > 0 || fileCount > 0;

  return (
    <Dialog open={open} onClose={isDeleting ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Excluir pasta?</DialogTitle>
      <DialogContent>
        {requiresConfirmation && hasContent ? (
          <Typography color="text.secondary">
            A pasta <strong>{folderName}</strong> contém {subfolderCount} subpastas e{" "}
            {fileCount} arquivos. Esta ação não pode ser desfeita.
          </Typography>
        ) : (
          <Typography color="text.secondary">
            Você está prestes a excluir a pasta <strong>{folderName}</strong>. Esta ação não
            pode ser desfeita.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={isDeleting} sx={{ textTransform: "none" }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={isDeleting}
          sx={{ textTransform: "none" }}
        >
          {isDeleting ? "Excluindo..." : "Excluir"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
